export default __webpack_public_path__ + "static/media/Products.80681ea1.PNG";